import React from "react";
import { Datagrid, TextField, List, ReferenceField, DateField, ShowButton, useListContext } from "react-admin";

const PanelEventsList = (props) => {
    const { filter } = props;
    const { data, ids } = useListContext();
    return (
        <List
            title=" "
            hasEdit={false}
            hasList={false}
            hasCreate={false}
            hasShow={false}
            filter={filter}
            basePath={"/panelevents"}
            resource="panelevents"
            component={"div"}
        >
            <Datagrid>
                {!props.ignoreZone &&
                    <ReferenceField
                        label="Zone"
                        source="zone_id"
                        reference="zones"
                        link="show"
                    >
                        <TextField source="name" />
                    </ReferenceField>}
                {!props.ignoreOrg && <ReferenceField
                    label="Organization"
                    source="org_id"
                    reference="organizations"
                    link="show"
                >
                    <TextField source="name" />
                </ReferenceField>}
                <TextField label="Event Type" source="eventType" />
                <DateField label="Updated At" source="updatedAt" />
                <ShowButton />
            </Datagrid>
        </List>
    );
};

export default PanelEventsList;